import React, {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import resourcesServices from '../services/resourcesServices';
import TextControl from '../components/customizedInputs/TextControl';
import { errorMessage } from '../errorHandler';
import { PDFDocument } from 'pdf-lib';
import BotonVolver from '../components/BotonVolver';

const RegistroUsuario = () => {
  let fileReader;

  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [formularioPDF, setFormularioPDF] = useState({});
  const [datosUsuarioPDF, setDatosUsuarioPDF] = useState([]);
  const [adjunto, setAdjunto] = useState(false);


  useEffect(() => {
    if(authInformation.autenticado === true){
      navigate(`/`);
    } else if(authInformation.autenticado === false){
      obtenerFormularioPdfsUsuario()
    }
  }, [authInformation]);

  useEffect(() => {
    if(adjunto){

      fileReader = new FileReader();
      fileReader.readAsArrayBuffer(adjunto)
      fileReader.onloadend = handleFileReader;
    }

  }, [adjunto]);


  const handleFileReader = async (e) => {
    const pdfDoc = await PDFDocument.load(fileReader.result);

    const form = pdfDoc.getForm();
    const fields = form.getFields();
    const campos_formulario_pdfs = [];
    console.log(formularioPDF.campos_formulario_pdfs)
    fields.forEach(field => {
      const field_name = field.getName();
      const field_value = field.getText();
      const new_field_name = formularioPDF.campos_formulario_pdfs.filter(field => field.nombre_pdf == field_name)[0]
      console.log(new_field_name.nombre_web, field_value, field_name)
      console.log(field_name)
      campos_formulario_pdfs.push({
        field_web: field_name,
        field_name: new_field_name.nombre_web,
        field_value: field_value,
      })

    })

    setDatosUsuarioPDF(campos_formulario_pdfs)
  }

  const obtenerFormularioPdfsUsuario = async () => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('formulario_pdfs', 1);
      setFormularioPDF(data);
      console.log(data)

    } catch (error) {
      errorMessage(error)
    }
  };

  const guardarRegistro = async () => {
    try {

      // const copiaFormularioPdfsUsuario = {...formularioPdfsUsuario}
      // copiaFormularioPdfsUsuario.campos_formulario_pdf_usuarios_attributes = copiaFormularioPdfsUsuario.campos_formulario_pdf_usuarios;

      // await resourcesServices.crearResource('registro_usuarios/guardar', {formulario_pdfs_usuario: copiaFormularioPdfsUsuario});

      // window.alert("Información actualizada")


    } catch (error) {
      errorMessage(error)
    }
  };


  const handleInput = (e) => {
    // const { name, value } = e.target;
    // setFormularioPDF({...formularioPDF,
    //   [name]: value
    // })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    guardarRegistro()
  }

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setAdjunto(files[0])
  };

  const mergedFields = () => {

  }

  return (
    <div>
      <h1>Registro <BotonVolver /></h1>
      <div className="card">
        {/* <pre>{JSON.stringify(formularioPDF, null, 2)}</pre> */}
        <div className="card-body px-0 pb-2 ms-3 me-3">
          <form onSubmit={handleFormSubmit}>
            Descargue el siguiente formulario interactivo y luego de completarlo, adjúntelo. <br />
            No sabés como hacerlo ? En el siguiente video te mostramos cómo. <a href="#" className='btn btn-primary' target='_blank'>Ver ayuda</a>
            {
              formularioPDF.archivoUrl && (
                <>
                <br /><a href={formularioPDF.archivoUrl} className='btn btn-success' target='_blank'>Descargar, completar y adjuntar</a>
                </>
              )
            }
            <div className="card mb-3">
              <div className="card-body">
                <div className="mb-3">
                  <label>Adjunte el archivo completado</label>
                  <input
                    placeholder="Adjunte el documento interactivo"
                    className="form-control"
                    onChange={handleFileChange}
                    accept='.pdf'
                    name="adjunto"
                    type="file"
                    id="adjunto" />
                </div>
              </div>
            </div>

            {
              datosUsuarioPDF && datosUsuarioPDF.length > 0 && (
                datosUsuarioPDF.filter(campo => campo.field_value).map((campo, idx) => (
                  <div key={idx}>
                    <b>{campo.field_name}:</b> {campo.field_value}
                  </div>
                ))
              )
            }

            <button className="btn btn-primary mt-3" type="submit">Registrate</button>
          </form>
        </div>
      </div>

    </div>
  );
};
export default RegistroUsuario;